import { Component } from '@angular/core';
import { GetConsentsTranslationPipe } from '@app/shared/pipes/get-consents-translation.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { CookieConsentBaseComponent } from '@app/core/cookie-consent/cookie-consent-base.component';

@Component({
  selector: 'app-simple-cookie-consent',
  imports: [
    GetConsentsTranslationPipe,
    TranslatePipe,
  ],
  templateUrl: './simple-cookie-consent.component.html',
})
export class SimpleCookieConsentComponent extends CookieConsentBaseComponent {
}
